module.exports = __webpack_public_path__ + "img/icon-9.996be7d2.svg";